//# sourceMappingURL=list.mjs.map
/// <reference types="./list.d.mts" />
import * as $events from "../../../../altar/redraw/dom/events/extra.mjs";
import * as $project from "../../../../data_types/data/project.mjs";
import * as $proposal from "../../../../data_types/data/proposal.mjs";
import * as $proposal_element from "../../../../data_types/data/proposal_element.mjs";
import * as $answer from "../../../../data_types/data/proposal_element/answer.mjs";
import * as $remote from "../../../../data_types/data/remote.mjs";
import * as $language from "../../../../data_types/data/translate/language.mjs";
import * as $colors from "../../../../ds/ds/colors.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $skeleton from "../../../../ds/ds/components/skeleton.mjs";
import * as $table from "../../../../ds/ds/components/table.mjs";
import * as $bool from "../../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../../gleam_stdlib/gleam/dict.mjs";
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $result from "../../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../../gleam_stdlib/gleam/string.mjs";
import * as $redraw from "../../../../redraw/redraw.mjs";
import * as $a from "../../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $h from "../../../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $html from "../../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $timestamp_ from "../../../../tiamat/gleam/time/timestamp_.mjs";
import * as $answer_effects from "../../../admin/effects/answer.mjs";
import * as $proposal_effects from "../../../admin/effects/proposal.mjs";
import * as $msg from "../../../data/msg.mjs";
import * as $store from "../../../data/store.mjs";
import { Ok, toList, Empty as $Empty } from "../../../gleam.mjs";
import * as $common from "../../../view/common.mjs";

function text(text) {
  return $h.div(toList([]), toList([$h.text(text)]));
}

function project_row(project) {
  return $table.row(
    toList([
      $table.cell(text("")),
      $table.cell(text(project.name)),
      $table.cell(text("")),
      $table.cell(text("")),
      $table.cell(text("")),
      $table.cell(text("")),
      $table.cell(text("")),
    ]),
  );
}

function proposal_languages(proposal) {
  let _pipe = proposal.metadata.languages;
  let _pipe$1 = $list.map(_pipe, $language.to_emoji);
  return $string.join(_pipe$1, " ");
}

function unmigrated_count(proposal_id, proposal_elements, answers) {
  let $ = $dict.get(proposal_elements, proposal_id);
  let $1 = $dict.get(answers, proposal_id);
  if ($ instanceof Ok && $1 instanceof Ok) {
    let elements = $[0];
    let loaded_answers = $1[0];
    let migrated_ids = $list.map(
      loaded_answers,
      (answer_v2) => { return answer_v2.answer_id; },
    );
    let _block;
    let _pipe = $list.flat_map(
      elements,
      (el) => {
        if (el instanceof $proposal_element.Question) {
          let question = el.question;
          return $dict.values(question.answer);
        } else {
          return toList([]);
        }
      },
    );
    _block = $list.count(
      _pipe,
      (answer_v1) => { return !$list.contains(migrated_ids, answer_v1.id); },
    );
    let count = _block;
    return $int.to_string(count);
  } else {
    return "?";
  }
}

function answers_count(proposal_id, answers) {
  let $ = $dict.get(answers, proposal_id);
  if ($ instanceof Ok) {
    let loaded_answers = $[0];
    return $int.to_string($list.length(loaded_answers));
  } else {
    return "?";
  }
}

function file_row(proposal, proposal_elements, answers) {
  return $table.row(
    toList([
      $table.cell(text("")),
      $table.cell(text("")),
      $table.cell(
        $html.a(
          $css.class$(
            toList([
              $css.text_decoration("none"),
              $css.color($colors.palette.text_body),
              $css.cursor("pointer"),
            ]),
          ),
          toList([$a.href("/proposal/versioning/" + proposal.id)]),
          toList([text(proposal.name)]),
        ),
      ),
      $table.cell(text(answers_count(proposal.id, answers))),
      $table.cell(
        text(
          (() => {
            let _pipe = proposal.created_at;
            return $timestamp_.to_date_yyyymmdd(_pipe, "/");
          })(),
        ),
      ),
      $table.cell(
        text(unmigrated_count(proposal.id, proposal_elements, answers)),
      ),
      $table.cell(text(proposal_languages(proposal))),
    ]),
  );
}

function has_answers_to_migrate(proposal_id, proposal_elements, answers) {
  let $ = $dict.get(proposal_elements, proposal_id);
  let $1 = $dict.get(answers, proposal_id);
  if ($ instanceof Ok && $1 instanceof Ok) {
    let elements = $[0];
    let loaded_answers = $1[0];
    let migrated_ids = $list.map(
      loaded_answers,
      (answer_v2) => { return answer_v2.answer_id; },
    );
    let _pipe = $list.flat_map(
      elements,
      (el) => {
        if (el instanceof $proposal_element.Question) {
          let question = el.question;
          return $dict.values(question.answer);
        } else {
          return toList([]);
        }
      },
    );
    return $list.any(
      _pipe,
      (answer_v1) => { return !$list.contains(migrated_ids, answer_v1.id); },
    );
  } else {
    return true;
  }
}

function pagination_controls(page_index, page_count, dispatch) {
  return $l.row(
    toList([$l.gap(8), $l.align("center")]),
    toList([]),
    toList([
      $button.secondary(
        toList([
          $a.disabled(page_index <= 0),
          $events.on_click(
            (_) => {
              let _pipe = new $msg.UserSelectedPage(page_index - 1);
              let _pipe$1 = new $msg.Project(_pipe);
              return dispatch(_pipe$1);
            },
          ),
        ]),
        toList([$h.text("←")]),
      ),
      $h.div(
        toList([]),
        toList([
          $h.text(
            ($int.to_string(page_index + 1) + " / ") + $int.to_string(
              $int.max(page_count, 1),
            ),
          ),
        ]),
      ),
      $button.secondary(
        toList([
          $a.disabled(page_index >= (page_count - 1)),
          $events.on_click(
            (_) => {
              let _pipe = new $msg.UserSelectedPage(page_index + 1);
              let _pipe$1 = new $msg.Project(_pipe);
              return dispatch(_pipe$1);
            },
          ),
        ]),
        toList([$h.text("→")]),
      ),
    ]),
  );
}

export function view() {
  return $redraw.component_(
    "ProjectFile",
    (_) => {
      let store = $store.use_state();
      let dispatch = $store.use_effect_dispatch();
      let msg_dispatch = $store.use_dispatch();
      let $ = $redraw.use_state(false);
      let hide_migrated = $[0];
      let set_hide_migrated = $[1];
      let projects = store.projects;
      let proposals = store.proposals;
      $redraw.use_effect(
        () => {
          if (proposals instanceof $remote.NotLoaded) {
            return undefined;
          } else if (proposals instanceof $remote.Loading) {
            return undefined;
          } else if (proposals instanceof $remote.Errored) {
            return undefined;
          } else {
            let proposals$1 = proposals[0];
            return $list.each(
              proposals$1.elements,
              (proposal) => {
                let element = $dict.get(store.proposal_elements, proposal.id);
                return $bool.guard(
                  $result.is_ok(element),
                  undefined,
                  () => {
                    dispatch(
                      $proposal_effects.fetch_proposal_elements(proposal.id),
                    );
                    dispatch($answer_effects.fetch_answers(proposal.id));
                    return undefined;
                  },
                );
              },
            );
          }
        },
        [proposals],
      );
      if (
        projects instanceof $remote.Loaded &&
        proposals instanceof $remote.Loaded
      ) {
        let projects_page = projects[0];
        let proposals_page = proposals[0];
        let _block;
        let _pipe = proposals_page.elements;
        _block = $list.group(
          _pipe,
          (proposal) => { return proposal.project_id; },
        );
        let proposals_by_project = _block;
        return $l.column(
          toList([$l.gap(12), $l.styles(toList([$css.z_index(8000)]))]),
          toList([]),
          toList([
            $common.page_title("Answer"),
            $l.row(
              toList([$l.gap(12), $l.align("center")]),
              toList([]),
              toList([
                $button.secondary(
                  toList([
                    $events.on_click(
                      (_) => { return set_hide_migrated(!hide_migrated); },
                    ),
                  ]),
                  toList([
                    $h.text(
                      (() => {
                        if (hide_migrated) {
                          return "Show all";
                        } else {
                          return "Hide migrated";
                        }
                      })(),
                    ),
                  ]),
                ),
                pagination_controls(
                  store.page_index,
                  $int.max(projects_page.page_count, proposals_page.page_count),
                  msg_dispatch,
                ),
              ]),
            ),
            $table.table(
              toList([]),
              toList([
                $table.headers(
                  toList([
                    (() => {
                      let _pipe$1 = $table.header("");
                      return $table.fit(_pipe$1);
                    })(),
                    (() => {
                      let _pipe$1 = $table.header("Project");
                      return $table.clamp(_pipe$1, "250px", 300);
                    })(),
                    (() => {
                      let _pipe$1 = $table.header("Question");
                      return $table.fit(_pipe$1);
                    })(),
                    (() => {
                      let _pipe$1 = $table.header("Answers");
                      return $table.fit(_pipe$1);
                    })(),
                    (() => {
                      let _pipe$1 = $table.header("Created at");
                      return $table.clamp(_pipe$1, "150px", 200);
                    })(),
                    (() => {
                      let _pipe$1 = $table.header("To migrate");
                      return $table.clamp(_pipe$1, "100px", 150);
                    })(),
                    (() => {
                      let _pipe$1 = $table.header("Languages");
                      return $table.clamp(_pipe$1, "100px", 200);
                    })(),
                  ]),
                ),
                $table.body(
                  $list.flat_map(
                    projects_page.elements,
                    (project) => {
                      let _block$1;
                      let _pipe$1 = proposals_by_project;
                      let _pipe$2 = $dict.get(_pipe$1, project.id);
                      let _pipe$3 = $result.unwrap(_pipe$2, toList([]));
                      _block$1 = $list.filter(
                        _pipe$3,
                        (p) => {
                          return !hide_migrated || has_answers_to_migrate(
                            p.id,
                            store.proposal_elements,
                            store.answers,
                          );
                        },
                      );
                      let visible_proposals = _block$1;
                      if (hide_migrated && visible_proposals instanceof $Empty) {
                        return visible_proposals;
                      } else {
                        let _pipe$4 = visible_proposals;
                        let _pipe$5 = $list.map(
                          _pipe$4,
                          (_capture) => {
                            return file_row(
                              _capture,
                              store.proposal_elements,
                              store.answers,
                            );
                          },
                        );
                        return $list.prepend(_pipe$5, project_row(project));
                      }
                    },
                  ),
                ),
              ]),
            ),
          ]),
        );
      } else {
        return $skeleton.full_width(200);
      }
    },
  );
}
